import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 md:py-16 bg-dark-800/50 border-y border-white/5" data-id="element-137">
      <div className="container mx-auto px-4" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-139">
          <motion.div animate={{
          rotate: [0, -3, 3, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="w-16 h-16 md:w-20 md:h-20 bg-gold-500/10 rounded-full flex items-center justify-center border-2 border-gold-500/30 mb-5 relative" data-id="element-140">
            <div className="absolute inset-0 bg-gold-500/20 rounded-full blur-xl" data-id="element-141" />
            <ShieldCheckIcon className="text-gold-500 relative z-10 w-8 h-8 md:w-10 md:h-10" data-id="element-142" />
          </motion.div>

          <h2 className="text-3xl md:text-5xl font-display text-white uppercase tracking-wide mb-2 leading-tight" data-id="element-143">
            7 Días <span className="text-gold-500" data-id="element-144">Garantía Total</span>
          </h2>

          <p className="text-base md:text-2xl font-medium text-gray-300 mb-3" data-id="element-145">
            Probalo o te devolvemos el 100%
          </p>

          <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-xl mb-5" data-id="element-146">
            Accedés al kit completo, recorrés las etapas. Si no es lo que
            esperabas: sin preguntas, sin formularios, sin drama.
          </p>

          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-dark-900 border border-white/10 text-xs text-gray-400 font-medium" data-id="element-147">
            <ShieldCheckIcon size={14} className="text-gold-500" data-id="element-148" />
            Tasa de devoluciones menor al 1%
          </div>
        </motion.div>
      </div>
    </section>;
}